import { INTL_LONG_DATE } from 'constants/dateFormats'
import { formatZonedDateForDisplay } from 'lib/datetime/dateUtils'
import { getCurrentIntl } from 'i18n/util/currentIntl'

type OfferMetadata = Pick<App.ExperienceOffer, 'id' | 'expirationDate' | 'location'>

export default function getDrawerBookableUntilDate(offer?: OfferMetadata): string | undefined {
  if (!offer?.expirationDate || !offer.id.startsWith('led') || !offer.location?.timezone) {
    return undefined
  }

  return formatZonedDateForDisplay(
    offer.expirationDate,
    offer.location.timezone,
    INTL_LONG_DATE,
    getCurrentIntl().locale,
  )
}
